module.exports = __webpack_public_path__ + "media/images/pocket-6d15e049c6afebe10fadbb84373d3998.svg";